const FREE_GIFT_VARIANT_ID = 32910923628591;
const THRESHOLD = 5000;

const PROMO_START = new Date('2026-05-22T00:00:00+01:00');
const PROMO_END = new Date('2026-06-31T23:59:59+01:00');

function isPromoActive() {
  const now = new Date();
  return now >= PROMO_START && now <= PROMO_END;
}

async function getCart() {
  const res = await fetch('/cart.js');
  return res.json();
}

let isHandling = false;

async function handleGift() {
  if (isHandling) return;
  isHandling = true;

  try {
    const cart = await getCart();
    const giftItem = cart.items.find(i => i.variant_id === FREE_GIFT_VARIANT_ID);
    const otherItems = cart.items.filter(i => i.variant_id !== FREE_GIFT_VARIANT_ID);
    const otherTotal = otherItems.reduce((sum, i) => sum + i.final_line_price, 0);

    if (isPromoActive() && otherTotal >= THRESHOLD && !giftItem) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: FREE_GIFT_VARIANT_ID, quantity: 1 }] })
      });
      location.reload();
    } else if ((!isPromoActive() || otherTotal < THRESHOLD) && giftItem) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: giftItem.key, quantity: 0 })
      });
      location.reload();
    }
  } finally {
    isHandling = false;
  }
}

document.addEventListener('DOMContentLoaded', handleGift);

document.addEventListener('change', function(e) {
  if (e.target.matches('input[name="updates[]"], input[type="number"]')) {
    setTimeout(handleGift, 1000);
  }
});

document.addEventListener('click', function(e) {
  setTimeout(handleGift, 1000);
});